import React from 'react';
import ReactDOM from 'react-dom/client';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{ 
        token: {
          colorPrimary: '#1890ff'
        }
      }}
    >
      <App />
    </ConfigProvider> {/* 修正：补充ConfigProvider的闭合标签 */}
  </React.StrictMode>
);

reportWebVitals();